import Vue from 'vue'
import VueMoment from 'vue-moment'
import Router from 'vue-router'
import Amortizations from './views/Amortization/Amortizations.vue'
import ModifyAmortization from './views/Amortization/ModifyAmortization.vue'
import Login from './views/Auth/Login.vue'
import VueCookies from 'vue-cookies'
import Register from './views/Auth/Register.vue'
import RegisterSuccess from './views/Auth/RegisterSuccess.vue'
import RegisterConfirmed from './views/Auth/RegisterConfirmed.vue'
import Profile from './views/Settings/Profile.vue'
import UserPlan from './views/Settings/ProfilePlan.vue'
import UserSettings from './views/Settings/UserSettings.vue'
import SearchPromissoryNotes from './views/Amortization/SearchPromissoryNotes.vue'
import HtmlEditor from './views/Editor/HtmlEditor.vue'
import HtmlEditorFabric from './views/Editor/HtmlEditorFabric.vue'
import Cropper from './views/Editor/Cropper.vue'
import MarginSettings from './views/Settings/MarginSettings.vue'
import NotifySettings from './views/Settings/NotifySettings.vue'
import RecoverPassword from './views/Auth/RecoverPassword.vue'
import RecoverSuccess from './views/Auth/RecoverSuccess.vue'

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import Toasted from 'vue-toasted'
import Vuex from 'vuex'

import axios from 'axios'
import VueCurrencyInput from 'vue-currency-input'


Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueMoment)
Vue.use(VueCookies)
Vue.use(VuejsDialog)
Vue.use(Toasted)
Vue.use(VueCurrencyInput)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/register/success',
            name: 'register-success',
            component: RegisterSuccess
        },
        {
            path: '/recover-success',
            name: 'recover-success',
            component: RecoverSuccess
        },
        {
            path: '/recover-password/:token',
            name: 'recover-password',
            component: RecoverPassword
        },
        {
            path: '/register/confirmed',
            name: 'register-confirmed',
            component: RegisterConfirmed
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                requiresAuth: true
            },
            children: [{
                path: 'settings',
                component: UserSettings,
                name: 'settings'
            },
                {
                    path: 'plan',
                    component: UserPlan,
                    name: 'plan'
                },
                {
                    path: 'margin-settings',
                    component: MarginSettings,
                    name: 'margin-settings'
                },
                {
                    path: 'notifications',
                    component: NotifySettings,
                    name: 'notifications'
                }
            ]
        },
        {
            path: '/amortizations',
            name: 'amortizations',
            component: Amortizations,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/amortizations/:id',
            name: 'modify_amortization',
            component: ModifyAmortization,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/search-promissory-notes',
            name: 'search_promissory_notes',
            component: SearchPromissoryNotes,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/editor',
            name: 'editor',
            component: HtmlEditor,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/editor-fabric',
            name: 'editor-fabric',
            component: HtmlEditorFabric,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/cropper',
            name: 'cropper',
            component: Cropper,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            redirect: '/login'
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (window.$cookies.get('token') == null || window.$cookies.get('user') == null) {
            next({
                path: '/login',
                params: {
                    nextUrl: to.fullPath
                }
            })
        } else {
            let user = window.$cookies.get('user')

            if (!user.is_completed && to.name !== 'settings') {
                next({
                    path: '/profile/settings'
                })
            } else {
                next()
            }

        }
    } else {
        next()
    }
})

export default router


// Add a request interceptor
axios.interceptors.request.use(function (config) {
    const token = window.$cookies.get('token');
    config.headers.Authorization = 'Bearer ' + token;

    return config;
});


// This is a global mixin, it is applied to every vue instance
Vue.mixin({
    data: function () {
        return {
            get isSidebarShown() {
                return (window.$cookies.get('sidebar') == 'true') ? true : false
            },
            get loggedUser() {
                return window.$cookies.get('user')
            },
            get isTrialUser() {
                if (window.$cookies.get('token') && window.$cookies.get('user')) {
                    var user = window.$cookies.get('user')
                    return user.roles.includes('USER_TRIAL')
                }
            }
        }
    },
    methods: {
        isLogged: function () {
            return window.$cookies.get('token') && window.$cookies.get('user')

        },
        isSidebarShow: function () {
            return (window.$cookies.get('sidebar') == 'true') ? true : false
        }
    }
})